<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="产品溯源"> </pageTitle>

    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:form_sn="row">
        <el-link type="primary" @click="purchaseOrder(row.row)">{{
          row.row.form_sn
        }}</el-link>
      </template>
      <template
        v-slot:operation="row"
        v-if="hasPermission('商品-商品溯源-查看')"
      >
        <div style="display: flex; align-items: center">
          <template>
            <div class="button button_revoke" @click="show(row.row)">
              <i class="iconfont el-icon-warning-outline"></i> 查看
            </div>

            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>
        </div>
      </template>

      <template v-slot:traceabilityPhotos="row">
        <el-image
          v-for="file in row.row.fileList"
          :key="file.url"
          style="max-width: 75px; max-height: 75px"
          :src="file.url"
          :preview-src-list="row.row.urls"
        >
        </el-image>

        <!-- <div
          v-if="row.row.fileList && row.row.fileList.length > 0"
          class="image-container"
        >
          <div v-for="file in row.row.fileList" :key="file.url">
            <img :src="file.url" alt="Image" @click="enlargeImage(file)" />
          </div>
        </div> -->

        <div
          v-if="enlargedImage"
          class="image-modal"
          @click.self="enlargedImage = null"
        >
          <div class="modal-content" @click.stop>
            <img :src="enlargedImage.url" alt="Enlarged Image" />
            <button @click="enlargedImage = null">Close</button>
          </div>
        </div>
      </template>
    </basicList>
    <sourceTracing
      v-if="sourceTracingParams.visible"
      :dialogParams="sourceTracingParams"
      @close="handleSourceTracingClose"
    >
    </sourceTracing>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { StockItemWayGetList, StockItemWayDel } from "@/api/product";
import { getRoles } from "@/utils";
import { orderBuyGetOne } from "@/api/purchasing";
import { orderSellGetOne } from "@/api/sale";

// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "productTraceability",
  components: {
    Treeselect,
    sourceTracing: () => import("./sourceTracing.vue"),
    previewComponents: () => import("@/components/previewComponents"),
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,

      actionUrl: "",

      // 溯源弹窗
      sourceTracingParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        flow_type: -1,
      },
      enlargedImage: null,

      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 180,
        search: [
          {
            label: "会员码",
            type: "input",
            key: "supplier_id",
          },
          {
            label: "溯源码",
            type: "input",
            key: "code_value",
          },
          {
            label: "类型",
            key: "item_way_type",
            type: "select",
            options: [
              {
                label: "采购",
                value: -1,
              },
              {
                label: "销售",
                value: 1,
              },
            ],
          },
          {
            label: "",
            type: "daterange",
            key: "update_time",
          },
          {
            label: "操作人",
            type: "input",
            key: "user_name",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
            fixed: "left",
          },
          {
            label: "类型",
            prop: "type",
            width: 110,
          },
          // {
          //   label: "溯源码",
          //   prop: "code_value",
          //   width: 240,
          // },
          {
            label: "订单号",
            prop: "form_sn",
            slot: true,
            width: 240,
          },
          {
            label: "会员信息",
            prop: "supplier_customer_number",
            width: 120,
          },
          {
            label: "订单时间",
            prop: "order_time",
            sortable: true,
            width: 180,
          },
          {
            label: "操作人",
            prop: "user_name",
            width: 100,
          },
          {
            label: "溯源照片",
            prop: "traceabilityPhotos",
            showOverflowTooltip: true,
            slot: true,
            width: 250,
          },
          {
            label: "更新时间",
            prop: "update_time",
            width: 250,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "purchaseOrder",
        code: "",
        viewObj: [],
      },
      temporaryRowData: {},
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    this.getlist();
  },
  methods: {
    purchaseOrder(row) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      if (row.type == "销售") {
        orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")(" +
                item.item_info.item_number +
                ")";
              item.freeze_num = item.item_info.freeze_num;
              item.price_distribution = this.$money(item.price_distribution);
              item.item_stock_single = item.item_info.item_stock_single;
              item.item_stock_package = item.item_info.item_stock_package;
              item.total_money = this.$money(item.total_money);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.single_num +
                "+" +
                item.package_num +
                "*" +
                item.item_info.in_package_num +
                ")" +
                "=" +
                item.total_money;
              item.total = item.num;
              //   Number(item.single_num) +
              //   Number(item.package_num) * Number(item.item_info.in_package_num);
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "客户",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "销售门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "业务员",
                    value: res.order_info.customer_user_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                ],
              },
              {
                title: "销售明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                    width: "500px",
                  },
                  {
                    label: "销售单价",
                    prop: "price_distribution",
                  },

                  {
                    label: "销售总量",
                    prop: "total",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "散",
                    //     prop: "single_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "箱",
                    //     prop: "package_num",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "总",
                    //     prop: "total",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    // ],
                  },
                  {
                    label: "小计金额",
                    prop: "total_money",
                    align: "center",
                    // children: [
                    //   {
                    //     label: "金额",
                    //     prop: "total_money",
                    //     width: 100,
                    //     align: "center",
                    //   },
                    //   {
                    //     label: "算法",
                    //     prop: "algorithm",
                    //     width: 200,
                    //     align: "center",
                    //   },
                    // ],
                  },
                ],
              },
              {
                title: "销售金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费收入",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "总数量",
                    value: res.order_info.num,
                  },
                  {
                    label: "运费支出",
                    value: this.$money(res.order_info.trans_money_self),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "净毛利",
                    value: this.$money(
                      Number(res.order_info.real_profit_money)
                    ),
                  },
                  {
                    label: "应收总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "收款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "收款账户",
                    prop: "account_name",
                  },
                  {
                    label: "收款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "收款信息",
                type: "object",
                value: [
                  {
                    label: "已收金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未收金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "订单备注",
                type: "object",
                value: [
                  {
                    label: "公司名称",
                    value: res.order_info.comp_remark,
                  },
                  {
                    label: "其它备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  // {
                  //   label: "品名",
                  //   prop: "item_name",
                  // },
                  // {
                  //   label: "会员号",
                  //   prop: "customer_id",
                  // },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
            this.previewParams.type = "sale";
          } else {
            this.$message.error("获取详情失败");
          }
        });
      } else {
        orderBuyGetOne({ form_sn: row.form_sn }).then((res) => {
          if (res.code == 1) {
            let payData = res.$pay_list.map((item) => {
              item.pay_price = this.$money(item.pay_price);
              item.all_price = this.$money(item.all_price);
              item.last_price = this.$money(item.last_price);
              return item;
            });
            let item_way = res.item_way.map((item) => {
              if (item.pics) item.pics = item.pics.split(",");
              return item;
            });
            let data = res.$order_list.map((item) => {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")";
              item.price_distribution = this.$money(item.price_distribution);
              item.need_item_stock_single = item.single_num;
              item.need_item_stock_package = item.package_num;
              item.total_money = this.$money(item.total_money);
              item.price_oneBox = (
                Number(item.price_distribution) * Number(item.in_package_num)
              ).toFixed(2);
              item.need_item_stock_total = (
                Number(item.need_item_stock_single) +
                Number(item.need_item_stock_package) *
                  Number(item.in_package_num)
              ).toFixed(0);
              item.algorithm =
                item.price_distribution +
                "*" +
                "(" +
                item.need_item_stock_single +
                "+" +
                item.need_item_stock_package +
                "*" +
                item.in_package_num +
                ") = " +
                item.total_money;
              return item;
            });
            this.previewParams.viewObj = [
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "供应商",
                    value: res.order_info.supplier_name,
                  },
                  {
                    label: "采购门店",
                    value: res.order_info.shop_name,
                  },
                  {
                    label: "采购人",
                    value: res.order_info.customer_name,
                  },
                  {
                    label: "制单人",
                    value: res.order_info.user_name,
                  },
                  {
                    label: "备注",
                    value: res.order_info.remark,
                  },
                ],
              },
              {
                title: "采购明细",
                type: "array",
                value: data,
                column: [
                  {
                    label: "商品名称",
                    prop: "name",
                  },
                  {
                    label: "单价",
                    prop: "price_distribution",
                  },
                  {
                    label: "采购数量",
                    prop: "num",
                    align: "center",
                  },
                  {
                    label: "小计",
                    prop: "total_money",
                    width: 200,
                  },
                ],
              },
              {
                title: "采购金额",
                type: "object",
                value: [
                  {
                    label: "商品金额",
                    value: this.$money(res.order_info.item_money),
                  },
                  {
                    label: "运费金额",
                    value: this.$money(res.order_info.trans_money),
                  },
                  {
                    label: "订单总金额",
                    value: this.$money(res.order_info.total_money),
                  },
                  {
                    label: "余额抵扣",
                    value: this.$money(res.order_info.pre_money),
                  },
                  {
                    label: "应付总金额",
                    value: this.$money(
                      Number(res.order_info.total_money) -
                        Number(res.order_info.pre_money)
                    ),
                  },
                ],
              },
              {
                title: "付款信息",
                type: "array",
                value: payData,
                column: [
                  {
                    label: "付款账户",
                    prop: "account_name",
                  },
                  {
                    label: "付款",
                    prop: "all_price",
                  },
                  {
                    label: "结款",
                    prop: "pay_price",
                  },
                  {
                    label: "余款",
                    prop: "last_price",
                  },
                  {
                    label: "时间",
                    prop: "create_time",
                  },
                  {
                    label: "类型",
                    prop: "pay_type",
                  },
                  {
                    label: "操作",
                    prop: "operation",
                  },
                ],
              },
              {
                title: "",
                type: "object",
                value: [
                  {
                    label: "已付金额",
                    value: this.$money(res.order_info.payed_money),
                  },
                  {
                    label: "未付金额",
                    value: this.$money(res.order_info.last_money),
                  },
                ],
              },
              {
                title: "溯源信息",
                type: "array",
                value: item_way,
                column: [
                  {
                    label: "ID",
                    prop: "id",
                    width: 80,
                  },
                  {
                    label: "溯源码",
                    prop: "code_value",
                  },
                  {
                    label: "操作人",
                    prop: "user_name",
                    width: 100,
                  },
                  {
                    label: "溯源照片",
                    prop: "pics",
                    width: 200,
                  },
                  {
                    label: "更新时间",
                    prop: "update_time",
                    width: 100,
                  },
                ],
              },
            ];

            this.previewParams.key = new Date().getTime();
            this.previewParams.visible = true;
          } else {
            this.$message.error("获取详情失败");
          }
        });
      }
      console.log(
        "%c [ row ]-158",
        "font-size:13px; background:pink; color:#bf2c9f;",
        row
      );
    },
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData);
    },
    // 表格选择数据事件
    handleSelectionChange(data) {
      //
    },
    enlargeImage(file) {
      this.enlargedImage = file;
    },
    // 查看事件
    show(row) {
      console.log(
        "%c [ row ]-206",
        "font-size:13px; background:pink; color:#bf2c9f;",
        row
      );
      row.item_way = {
        pics: row.pics,
        code_value: row.code_value,
      };
      this.sourceTracingParams.key = new Date().getTime();
      this.sourceTracingParams.data = []; //order_list
      this.sourceTracingParams.visible = true;
      this.sourceTracingParams.flow_type = row.type.includes("销售") ? 1 : -1;
      this.sourceTracingParams.memberId = row.type.includes("销售")
        ? row.customer_id
        : row.supplier_id;
      this.sourceTracingParams.item_way_num = row.item_way_num;
      this.sourceTracingParams.price = row.supplier_id;
      this.sourceTracingParams.type = "product";
      this.sourceTracingParams.form_sn = row.type.includes("销售")
        ? row.sell_form_sn
        : row.buy_form_sn;
      this.sourceTracingParams.order_id = 0;
      this.sourceTracingParams.item_way_data = row;
    },
    handleSourceTracingClose() {
      this.sourceTracingParams.id = 0;
      this.sourceTracingParams.key = "";
      this.sourceTracingParams.visible = false;
      this.sourceTracingParams.flow_type = 0;
      this.getlist();
    },
    // 删除事件
    deleteRows(row) {
      this.$confirm("删除此条溯源记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.id) {
          // this.basicListconfig.data = this.basicListconfig.data.filter(
          //   (item) => item.item_id != row.item_id
          // );
          StockItemWayDel({
            comp_id: this.compId,
            id: row.id,
          }).then((res) => {
            if (res.code == 1) {
              // this.basicListconfig.data = this.basicListconfig.data.filter(item => item.item_id != row.item_id);
              this.getlist();
            } else {
              this.$message.success("删除失败");
            }
          });
        } else {
          this.$message.success("没有选中记录");
        }
      });
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      StockItemWayGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            //item.name = item.customer_name + item.supplier_name;

            // 朔源类型
            item.type = item.buy_form_sn ? "采购" : "销售";
            // 订单号
            item.form_sn = item.buy_form_sn
              ? item.buy_form_sn
              : item.sell_form_sn;
            // 会员号
            item.supplier_customer_number = item.buy_form_sn
              ? item.supplier_id
              : item.customer_id;
            // 订单时间
            item.order_time = item.buy_form_sn ? item.buy_time : item.sell_time;
            item.urls = !item.pics
              ? []
              : item.pics.split(",").map((item) => {
                  return item;
                });
            item.fileList = !item.pics
              ? []
              : item.pics.split(",").map((item) => {
                  return {
                    url: item,
                    name: item,
                  };
                });
            return item;
          });
          this.basicListconfig.total = res.count;
        } else if (res.code == 0) {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.image-container {
  display: flex;
  /* 使用flex布局来并排显示图片 */
  flex-wrap: wrap;
  /* 允许图片换行 */
  justify-content: flex-start;
  /* 图片靠左显示 */
  align-items: center;
  /* 垂直居中 */
  max-height: 75px;
  /* 容器的最大高度 */
  margin: 5px;
}

img {
  max-width: 75px;
  /* 图片的最大宽度 */
  max-height: 75px;
  /* 图片的最大高度 */
  margin-right: 5px;
  /* 图片之间的间距 */
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* 确保模态框在最上层 */
}

.modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: default;
  /* 防止默认的手型光标 */
}

.modal-content img {
  max-width: 90%;
  max-height: 90%;
}

.modal-content button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

/* 防止点击 modal-content 外部时关闭模态框 */
.modal-content {
  pointer-events: auto;
  /* 允许内部元素响应点击事件 */
}
</style>



// WEBPACK FOOTER //
// src/views/productTraceability/index.vue